import React, { Fragment } from 'react';
import uuid from 'uuid/v4';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const GenericToggleSwitch = props => {
  const { title, switchArray, activeSwitch, perfomedFunc } = props;

  const handleClick = data => {
    perfomedFunc(data);
  };

  return (
    <Fragment>
      <div className="genericTitle">{title}</div>
      <div className="genericToggleSwitch">
        {switchArray.map((res, i) => (
          <button
            type="button"
            key={uuid()}
            onClick={() => handleClick(res)}
            className={`custom-btn ${activeSwitch === i && 'activeBtn'}`}
            disabled={!res.enabled}
          >
            <span
              className={classNames('check--label-text', {
                'check--label-text-selected': activeSwitch === i && 'activeBtn',
              })}
            >
              {res.label}
            </span>
          </button>
        ))}
      </div>
    </Fragment>
  );
};
GenericToggleSwitch.propTypes = {
  title: PropTypes.string.isRequired,
  switchArray: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSwitch: PropTypes.number.isRequired,
  perfomedFunc: PropTypes.func.isRequired,
};

export default GenericToggleSwitch;
